<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-form-model
      layout="horizontal"
      :model="formInline"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      @submit="handleSubmit"
      @submit.native.prevent
    >
      <a-row>
        <a-col :span="12"> 基本信息 </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="活动名称">
            <a-input v-model="activityName" placeholder="请输入活动名称">
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2">
          <a-form-model-item label="活动时间">
            <a-range-picker format="YYYY-MM-DD HH:mm:ss" @change="onChange" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="拼团人数">
            <a-input
              v-model="formInline.ptPeoples"
              placeholder="请输入砍价成功所需人数"
            >
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2">
          <a-form-model-item label="拼团时长">
            <a-input
              v-model="formInline.ptTimeLong"
              placeholder="自发起砍价多久（分钟）结束砍价"
            >
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="活动商品">
            <a-button
              type="primary"
              :style="{ margin: '0 0 24px 0' }"
              @click="showModal"
            >
              选择商品
            </a-button>
            <a-modal
              class="main"
              v-model="visible"
              :width="900"
              title="商品选择器"
              @ok="handleOk"
            >
              <div class="model-search">
                <a-input
                  class="s-input"
                  v-model="name"
                  placeholder="搜索商品名称"
                />
                <a-button class="s-btn" type="primary" @click="query"
                  >查询</a-button
                >
                <a-button class="s-btn" @click="reset">重置</a-button>
              </div>
              <div class="main-model">
                <div>
                  <a-tree
                    class="tree"
                    @check="onCheck"
                    @select="onSelect"
                    :tree-data="treeData"
                    show-icon
                    default-expand-all
                    :default-selected-keys="['0-0-0']"
                  >
                    <a-icon slot="switcherIcon" type="down" />
                    <a-icon slot="smile" type="smile-o" />
                    <a-icon slot="meh" type="smile-o" />
                    <template slot="custom" slot-scope="{ selected }">
                      <a-icon :type="selected ? 'frown' : 'frown-o'" />
                    </template>
                  </a-tree>
                </div>
                <div class="right">
                  <div
                    class="card"
                    v-for="(item, index) in tokens"
                    :key="index"
                    :class="{ active: currentIndex === index }"
                    @click="details(item, index)"
                  >
                    <img :src="item.img" alt="" />
                    <div class="aaa">
                      <h4 class="name">{{ item.name }}</h4>
                       <h3 class="num" v-if="tokens[0].typeSonId == 654" >游戏币数量：{{item.goodsProperties.gameCurrencyNumber}}</h3>
                      <h3 class="num" v-if="tokens[0].typeSonId == 655" >门票次数:{{item.goodsProperties.ticketsType}}</h3>
                      <div class="flex">
                        <h3 class="price">{{item.minSpecPriceStr}}</h3>
                        <span class="xiajia" v-show="item.shelf === false"
                          >已下架</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a-modal>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-table
            v-if="show"
            class="table"
            :columns="columns"
            :row-key="(record) => record.objId"
            :data-source="data"
            @loading="loading"
          >
            <template slot="operation">
              <a href="javascript:;" @click="del">删除</a>
            </template>
            <template slot="goodsImg" slot-scope="img">
              <img :src="img" alt="" />
            </template>
            <template slot="stock">
              <a-input-number
                id="inputNumber"
                v-model="formInline.stock"
                placeholder="请输入"
                :min="1"
                :max="99999"
                @change="onChange"
              />
            </template>
            <template slot="ptDiscount">
              <a-input-number
                id="inputNumber"
                v-model="formInline.ptDiscount"
                placeholder="请输入"
                :min="1"
                :max="10"
                @change="onChange"
              />
              折
            </template>
          </a-table>
        </a-col>
      </a-row>
      <a-button @click="save">保存</a-button>
      <a-button @click="goBack">返回</a-button>
    </a-form-model>
  </div>
</template>

<script>
import {
  getTokensList,
  bargainingGoodListDetails,
  bargainingAdd,
  getSeachList,
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const treeData = [
  {
    title: "代币套餐",
    key: "1",
    slots: {
      icon: "smile",
    },
    // children: [
    //   { title: "leaf", key: "0-0-0", slots: { icon: "meh" } },
    //   { title: "leaf", key: "0-0-1", scopedSlots: { icon: "custom" } },
    // ],
  },
  {
    title: "门票套餐",
    key: "2",
    slots: {
      icon: "smile",
    },
  },
];
const columns = [
  {
    title: "商品名称",
    dataIndex: "name",
    sorter: true,
    scopedSlots: { customRender: "name" },
  },
  {
    title: "商品封面图",
    dataIndex: "goodsImg",
    scopedSlots: { customRender: "goodsImg" },
  },
  {
    title: "原价",
    dataIndex: "original",
    scopedSlots: { customRender: "original" },
  },
  {
    title: "拼团折扣",
    dataIndex: "ptDiscount",
    scopedSlots: { customRender: "ptDiscount" },
  },
  {
    title: "拼团库存",
    dataIndex: "stock",
    scopedSlots: { customRender: "stock" },
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
  },
];
export default {
  data() {
    return {
      currentIndex: "",
      loading: false,
      data: [],
      show: false,
      columns,
      objId: "",
      visible: false,
      treeData,
      tokens: "", // 代币套餐数据
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      activityName: "",
      formInline: {
        ptDiscount: "",
        ptPeoples: "",
        ptTimeLong: "",
        stock: "",
        goodsId: "",
        specId: "",
        goodsType: "pt",
      },
      endTime: "",
      startTime: "",
      name: "",
      nameSelceted: "1",
    };
  },
  // cutMaxPeople cutTimeLong  stock cutPrice
  methods: {
    query() {
      if (this.name !== "") {
        if (this.nameSelceted === "1") {
          getSeachList(10, 1, 653, 654, this.name).then((res) => {
            if (res.data.length > 0) {
              this.tokens = res.data;
            } else {
              this.tokens = [];
            }
          });
        } else {
          getSeachList(10, 1, 653, 655, this.name).then((res) => {
            if (res.data.length > 0) {
              this.tokens = res.data;
            } else {
              this.tokens = [];
            }
          });
        }
      } else {
        message.warning("商品名称不可为空");
      }
    },
    reset() {
      this.name = "";
      if (this.nameSelceted === "1") {
        getTokensList(10, 1, 653, 654).then((res) => {
          this.tokens = res.data;
          console.log(res);
        });
      } else {
        getTokensList(10, 1, 653, 655).then((res) => {
          this.tokens = res.data;
          console.log(res);
        });
      }
    },
    onChange(date, dateString) {
      console.log(date, dateString);
      this.startTime = dateString[0];
      this.endTime = dateString[1];
    },
    showModal() {
      this.show = false;
      this.visible = true;
      console.log("===============");
      getTokensList(10, 1, 653, 654).then((res) => {
        this.tokens = res.data;
        console.log(res);
      });
    },
    onCheck(checkedKeys, info) {
      console.log("onCheck", checkedKeys, info);
    },
    goBack() {
      this.$router.push("/home/groupGoods/groupGoodsHome");
    },
    onSelect(selectedKeys, info) {
      this.nameSelceted = selectedKeys[0];
      console.log("selected", this.nameSelceted);
      this.name = "";
      if (selectedKeys[0] === "1") {
        getTokensList(10, 1, 653, 654).then((res) => {
          this.tokens = res.data;
          console.log(res);
        });
      }
      if (selectedKeys[0] === "2") {
        getTokensList(10, 1, 653, 655).then((res) => {
          this.tokens = res.data;
          console.log(res);
        });
      }
    },
    save() {
      let obj = {
        activityName: this.activityName,
        endTime: this.endTime,
        startTime: this.startTime,
        specList: [],
      };
      obj.specList.push(this.formInline);
      bargainingAdd(obj).then((res) => {
        if (res.code === "0000") {
          message.success(res.info);
          this.$router.push("/home/groupGoods/groupGoodsHome");
        } else {
          message.warning("请选择商品");
        }
      });
    },
    handleOk() {
      this.visible = false;
      bargainingGoodListDetails(this.objId).then((res) => {
        this.data = res.data.spec;
        this.formInline.goodsId = res.data.spec[0].goodsId;
        this.formInline.specId = res.data.spec[0].objId;
      });
      this.show = true;
    },
    del() {
      this.show = false;
      message.success("删除成功");
    },
    details(item, index) {
      this.objId = item.objId;
      this.currentIndex = index;
      console.log(item);
    },
    handleSubmit() {},
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
}
.table {
  width: 1500px;
}

.input {
  width: 200px;
}

img {
  width: 90px;
  margin-right: 10px;
  height: 90px;
}

.main-model {
  display: flex;
  height: 400px;
}

.model-search {
  display: flex;
  margin-bottom: 20px;
}

.s-input {
  width: 400px;
  margin: 0 20px;
}

.s-btn {
  margin: 0 20px;
}

.right {
  display: flex;
  height:400px;
  /* width: 1000px; */
  flex-wrap: wrap;
  margin-left: 50px;
  overflow-y: scroll;
}


/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 10px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 100px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.3);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: rgba(129, 137, 160, 0.4);
  border-radius: 10px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.5);
}
/* 滚动条滑块:hover */
::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(129, 137, 160, 0.4);
}

.card {
  display: flex;
  padding: 0 5px;
  align-items: center;
  width: 300px;
  height: 100px;
  border: 1px solid grey;
  margin: 10px;
}

.active {
  border: 1px solid rgb(21, 105, 214);
}

.none {
  border: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/merchandising/groupGoods/groupGoodsAdd.vue